<template>
    <div>
      <el-tabs v-model="tabsKey"
          type="card" @tab-click="backSearch">
          <el-tab-pane name="search" label="查詢">
              <Search  @detailTabs="detailTabs" />
          </el-tab-pane>
          <el-tab-pane name="add"  label="新增" v-if="isShowAdd">
              <Add @back="back" />
          </el-tab-pane>
          <el-tab-pane name="edit" label="編輯" v-if="isShowEdit" >
              <Edit @back="back" :type="type" :productKey="productKey" />
          </el-tab-pane>
          <el-tab-pane name="detail" label="詳細" v-if="isShowDetail">
              <Detail :productKey="productKey" :type="type"  @back="back"  @editTabs="editTabs" />
          </el-tab-pane>
      </el-tabs>
      
    </div>
</template>

<script>
import Search from './Search'
import Add from './Add'
import Edit from './Edit'
import Detail from './Detail'
    export default {
        name: 'products',
        data() {
            return {
                tabsKey: 'search',
                isShowAdd: true,
                isShowEdit: false,
                isShowDetail: false,
                productKey: '',
                type: null
            }
        },
        components: {
            Search,
            Add,
            Edit,
            Detail
        },
        methods: {
           back: function(){
               this.tabsKey = "search"
               this.isShowAdd = true
               this.isShowEdit = false
               this.isShowDetail = false
           },
         
           editTabs: function(data){
               this.productKey = data.key
               this.type = data.type
               this.isShowEdit = true
               this.isShowAdd = false
               this.isShowDetail = false
               this.tabsKey = 'edit'
           },
           detailTabs: function(data){
               this.productKey = data.key
               this.type = data.type
               this.isShowAdd = false
               this.isShowDetail = true
               this.tabsKey = 'detail'
           },
           backSearch: function(tab, event){
               if (tab.name == 'search') {
                  this.back()
               }
           }
        },
    }
</script>

<style lang="scss" scoped>
    
</style>